import React from "react";
import {
  BarChart23,
  Cloud13,
  HorizontalBarChart,
  LineChart13,
  LineChart23,
  Pie13,
} from "./charts";

export const CustomerExperience = () => (
  <svg viewBox="0 0 108 136">
    <LineChart13 x={8} y={8} />
    <LineChart23 x={40} y={8} />

    <HorizontalBarChart x={8} y={40} />
    <BarChart23 x={40} y={40} />

    <HorizontalBarChart x={8} y={72} />
    <HorizontalBarChart x={40} y={72} />
    <HorizontalBarChart x={72} y={72} />

    <Cloud13 x={40} y={104} />
    <Cloud13 x={72} y={104} />
    <Pie13 x={8} y={104} />
  </svg>
);
